import React from 'react';

import { Grid, makeStyles, Divider } from '@material-ui/core';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import {
  AvgMaxCountAccess,
  PeriodCountAccess,
  DateFilterFields,
} from 'modules/environments/interfaces';
import { filterAvgMaxOptions, filterPeriodOptions } from 'utils/graphs';
import FilterSelector from 'components/FilterSelector';
import { getEnvironmentPerformanceMemoryRequest } from 'modules/environments/actions';
import i18n from 'i18n';
import { useParams } from 'react-router';
import DateFilter from 'components/DateFilter';
import styles, { overrideFilter } from './styles';
import MemoryGraph from './MemoryGraph';

interface MemoryGraphModalProps {
  periodFilter: PeriodCountAccess;
  avgMaxFilter: AvgMaxCountAccess;
  getEnvironmentPerformanceMemoryRequest: ({ id, query }) => void;
}

const MemoryGraphModal = ({
  periodFilter,
  avgMaxFilter,
  getEnvironmentPerformanceMemoryRequest,
}: MemoryGraphModalProps) => {
  const { id } = useParams<{
    id: string;
  }>();
  const classes = makeStyles(styles())();

  const [period, setPeriod] = React.useState<PeriodCountAccess | string>(
    periodFilter
  );
  const [avgMax, setAvgMax] = React.useState<AvgMaxCountAccess | string>(
    avgMaxFilter
  );
  const [dateFilter, setDateFilter] = React.useState<DateFilterFields>({
    'start-date': '',
    'end-date': '',
  });
  const [openDateFilter, setOpenDateFilter] = React.useState(false);

  React.useEffect(() => {
    const query =
      dateFilter?.['start-date'] && dateFilter?.['end-date']
        ? dateFilter
        : { period };
    getEnvironmentPerformanceMemoryRequest({ id, query });
  }, [getEnvironmentPerformanceMemoryRequest, id, period, dateFilter]);

  return (
    <Grid container className={classes.modalGraph}>
      <Grid container className={classes.legend}>
        <Grid item className={classes.filtersContainer}>
          <DateFilter
            onOpenFilter={setOpenDateFilter}
            onSubmit={setDateFilter}
          />
          {!openDateFilter && (
            <FilterSelector
              overrideClasses={overrideFilter}
              options={filterPeriodOptions(setPeriod)}
              currentValue={{
                label: i18n.t(
                  `ENVIRONMENT_DASHBOARD.LAST_${period.toUpperCase()}`
                ),
                onClick: () => null,
              }}
            />
          )}
        </Grid>
        <Grid className={classes.filterAvgMaxContainer}>
          <Divider
            variant="middle"
            orientation="vertical"
            className={classes.divider}
          />

          <FilterSelector
            overrideClasses={overrideFilter}
            options={filterAvgMaxOptions(setAvgMax)}
            currentValue={{
              label: i18n.t(`PERFORMANCE_PAGE.${avgMax.toUpperCase()}_KEY`),
              onClick: () => null,
            }}
          />
        </Grid>
      </Grid>
      <MemoryGraph filter={avgMax} />
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { periodFilter, environmentAvgMaxFilterMemory },
}: ApplicationState) => ({
  periodFilter,
  avgMaxFilter: environmentAvgMaxFilterMemory,
});

export default connect(mapStateToProps, {
  getEnvironmentPerformanceMemoryRequest,
})(MemoryGraphModal);
